import { render, staticRenderFns } from "./my-frame.vue?vue&type=template&id=b852c8bc&scoped=true"
import script from "./my-frame.vue?vue&type=script&lang=js"
export * from "./my-frame.vue?vue&type=script&lang=js"
import style0 from "./my-frame.vue?vue&type=style&index=0&id=b852c8bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b852c8bc",
  null
  
)

export default component.exports